<template>
  <div  class="page page-home">

    <template v-if="this.data?.sections">
      <component
        v-for="(section, i) in this.data?.sections"
        :key="i"
        :is="section.blocName"
        :content="section"
      ></component>
    </template>

    <Footer />
    <GridHelper />
  </div>
</template>

<script>
import GridHelper from '@/components/GridHelper.vue'
import Footer from '@/components/Footer.vue'

import PlayerFull from '@/components/PlayerFull.vue'
import MainText from '@/components/MainText.vue'
import ImagesLinks from '@/components/ImagesLinks.vue'
import AgeGate from '@/components/AgeGate.vue'

import i18n from '@/i18n/i18n'

import signals from '@/store/signals'

export default {
  name: 'Home',
  components: {
    PlayerFull,
    MainText,
    ImagesLinks,
    AgeGate,
    Footer,
    GridHelper
  },
  beforeMount () {
    window.scrollTo(0, 0)
  },
  mounted () {
    signals.resetScrollama.dispatch()
  },
  data () {
    return {
      data: i18n.global.messages[i18n.global.locale].home,
    }
  },
  watch:{
    $route (to, from){
      this.data = i18n.global.messages[i18n.global.locale].home
    }
  } 
}
</script>

<style lang="scss">
 
</style>
